import * as React from 'react'
import PropTypes from 'prop-types'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { DayPicker } from 'react-day-picker'

function Calendar({ className, classNames, showOutsideDays = true, fromYear = 1900, toYear, ...props }) {
  const currentYear = new Date().getFullYear()
  const endYear = toYear || currentYear

  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={`p-3 ${className || ''}`}
      classNames={{
        months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
        month: 'space-y-4',
        caption: 'flex justify-center pt-1 relative items-center gap-1',
        caption_label: 'hidden',
        caption_dropdowns: 'flex gap-2',
        dropdown: 'px-2 py-1 rounded-md border border-gray-300 text-sm bg-white hover:bg-gray-50',
        dropdown_month: 'px-2 py-1 rounded-md border border-gray-300 text-sm bg-white hover:bg-gray-50',
        dropdown_year: 'px-2 py-1 rounded-md border border-gray-300 text-sm bg-white hover:bg-gray-50',
        nav: 'space-x-1 flex items-center',
        nav_button:
          'inline-flex items-center justify-center h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100 rounded-md hover:bg-gray-100',
        nav_button_previous: 'absolute left-1',
        nav_button_next: 'absolute right-1',
        table: 'w-full border-collapse space-y-1',
        head_row: 'flex',
        head_cell: 'text-gray-500 rounded-md w-9 font-normal text-[0.8rem]',
        row: 'flex w-full mt-2',
        cell: 'text-center text-sm p-0 relative',
        day: 'h-9 w-9 p-0 font-normal hover:bg-gray-100 rounded-md inline-flex items-center justify-center cursor-pointer',
        day_selected: 'bg-gray-900 text-white hover:bg-gray-900 hover:text-white focus:bg-gray-900 focus:text-white',
        day_today: 'bg-gray-100 text-gray-900 font-semibold',
        day_outside: 'text-gray-400 opacity-50',
        day_disabled: 'text-gray-400 opacity-50 cursor-not-allowed',
        day_hidden: 'invisible',
        ...classNames
      }}
      captionLayout="dropdown"
      fromYear={fromYear}
      toYear={endYear}
      components={{
        IconLeft: () => <ChevronLeft className="h-4 w-4" />,
        IconRight: () => <ChevronRight className="h-4 w-4" />
      }}
      {...props}
    />
  )
}
Calendar.displayName = 'Calendar'

Calendar.propTypes = {
  className: PropTypes.string,
  classNames: PropTypes.object,
  showOutsideDays: PropTypes.bool,
  fromYear: PropTypes.number,
  toYear: PropTypes.number
}

export { Calendar }
